import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PaymentPage from "@/pages/PaymentPage";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/pay" element={<PaymentPage />} />
        <Route path="*" element={<Navigate to="/pay" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
